import * as React from 'react';
import { Col, Label } from "reactstrap";
import { withTranslation } from 'react-i18next';
declare var require: any;

const oopsPic = require("../../Assets/imgs/oopsPic.png") as string;
interface ErrorBoundaryState {
    hasError: boolean;
}
interface ErrorBoundaryProps {
    children?: any;
    t: any;
}


class ErrorBoundary extends React.Component<ErrorBoundaryProps, ErrorBoundaryState> {
    state = {
        hasError: false
    };

    static getDerivedStateFromError(error: any) {
        console.error(error);
        // Update state so the next render will show the fallback UI.
        return { hasError: true };
    }

    componentDidCatch(error: any, errorInfo: any) {
        // You can also log the error to an error reporting service
        //logErrorToMyService(error, errorInfo);Apllication Insight
        console.error(error, errorInfo);
    }

    render() {
        if (this.state.hasError) {
            return <div className=" mainExternal signin heightSighnIn extraHeight">
                <div className="container">
                    <div className="row py-5 align-items-center">
                        <Col sm="10" md="10" lg="10" className="mx-auto d-table h-100 containerMsg">
                            <div className=" text-center p10" >
                                <img src={oopsPic} alt="" className="mt-3" />
                                <div className="d-block mt-3 text-center m10 align-self-center justify-content-center">
                                    <Label className="text-Grey font-32 t-bold d-block mb-2">{this.props.t('Oopssomethingwentwrong')}  </Label>
                                    <Label className="text-Grey font-24 d-block m-0"> {this.props.t("Reloadandiftheissuepersistspleasecontactus")} </Label>
                                </div>
                            </div>
                        </Col>
                    </div>
                </div>
            </div>
            ;
        }

        return this.props.children;
    }
}
export default withTranslation()(ErrorBoundary as any);
